import React from 'react';
import './LineButton.css';

const LineButton = () => {
  const lineUrl = 'https://line.me/R/ti/p/@703rvibx';

  const handleClick = () => {
    // 追蹤由 index.html 的 LINE 按鈕腳本處理
    window.open(lineUrl, '_blank');
  };

  return (
    <div className="line-button-container">
      <button 
        className="line-button" 
        onClick={handleClick}
        aria-label="立即加 Line 線上免費估價，預約再折500元"
      >
        <span className="line-button-text">立即加 Line 線上免費估價｜預約再折 $500</span>
      </button>
    </div>
  );
};

export default LineButton;

